<template>
    <div v-if="result.qualityRating">
      <hp5-spacing-vertical xs="xxs"></hp5-spacing-vertical>
      <div class="cost-rating">
        <hp5-semantic size-selection="xs">
          <p>Quality of this provider’s care group is {{ qualityRatingDescription }}               
             <!-- <hp5-link-text-basic size="xs" href="/fcp/cost-and-quality/" :text="qualityRatingDescription" target="_blank" /> -->
           </p>
        </hp5-semantic>
      </div>
    </div>
</template>

<script setup>
  
    const props = defineProps({
        result: Object
    })

    const qualityRatingDescription = computed(() => {
      if (props.result.qualityRating.value === 4) {
        return 'higher than average';
      } else if (props.result.qualityRating.value >= 2 && props.result.qualityRating.value <= 3) {
        return 'average';
      } else if (props.result.qualityRating.value < 2) {
        return 'lower than average';
      }
      return '';
    });

</script>
  
<style lang="scss" scoped>
  .quality-rating {
    display: flex;
  }
  
  .rating {
    padding-top: 2px;
    padding-left: var(--spacing-xxs);
    padding-right: var(--spacing-xs);
  }
</style>